export default __webpack_public_path__ + "static/media/img7.be8486b5.JPG";